const context = {
  appId: 0,
  versionCode: 0,
  platform: "unrecognized",
  webApiVersion: 0,
  nativeAndroidApi: window.VicmanNativeApi,
  nativeIosApi: window.webkit?.messageHandlers?.VicmanNativeApi,
};

if (context.nativeAndroidApi) {
  context.platform = "android";
} else if (context.nativeIosApi) {
  context.platform = "ios";
}

export function webviewContext(overrides) {
  if (typeof overrides !== "undefined") {
    return Object.assign(context, overrides);
  }

  return context;
}
